var Apidae_Search = (function(){
    var self = {};
    //var menuCloseCtrl = $('#theSearch .close-button');

    self.price = function() {
        if ($('#nouisliderPrice').length) {
            var sliderPrice = document.getElementById('nouisliderPrice');
            var minNumberPrice = document.getElementById('min-number-price');
            var maxNumberPrice = document.getElementById('max-number-price');
            var minRangePrice = document.getElementById('min-range-price');
            var maxRangePrice = document.getElementById('max-range-price');

            noUiSlider.create(sliderPrice, {
                start: [minNumberPrice.value, maxNumberPrice.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangePrice.innerHTML),
                    'max': Number(maxRangePrice.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function ( value ) {
                        return value + '';
                    },
                    from: function ( value ) {
                        return value.replace('', '');
                    }
                }
            });

            sliderPrice.noUiSlider.on('update', function (values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberPrice.value = value;
                } else {
                    minNumberPrice.value = value;
                }
            });

            sliderPrice.noUiSlider.on('change', function(){
                self.search();
            });

            minNumberPrice.addEventListener('change', function () {
                sliderPrice.noUiSlider.set([this.value, null]);
            });

            maxNumberPrice.addEventListener('change', function () {
                sliderPrice.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.capacity = function() {
        if ($('#nouisliderCapacity').length) {
            var sliderCapacity = document.getElementById('nouisliderCapacity');
            var minNumberCapacity = document.getElementById('min-number-capacity');
            var maxNumberCapacity = document.getElementById('max-number-capacity');
            var minRangeCapacity = document.getElementById('min-range-capacity');
            var maxRangeCapacity = document.getElementById('max-range-capacity');

            noUiSlider.create(sliderCapacity, {
                start: [minNumberCapacity.value, maxNumberCapacity.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeCapacity.innerHTML),
                    'max': Number(maxRangeCapacity.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function ( value ) {
                        return value + '';
                    },
                    from: function ( value ) {
                        return value.replace('', '');
                    }
                }
            });

            sliderCapacity.noUiSlider.on('update', function (values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberCapacity.value = value;
                } else {
                    minNumberCapacity.value = value;
                }
            });

            sliderCapacity.noUiSlider.on('change', function(){
                self.search();
            });

            minNumberCapacity.addEventListener('change', function () {
                sliderCapacity.noUiSlider.set([this.value, null]);
            });

            maxNumberCapacity.addEventListener('change', function () {
                sliderCapacity.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.nombreChambres = function() {
        if ($('#nouisliderNombreChambres').length) {
            var sliderNombreChambres = document.getElementById('nouisliderNombreChambres');
            var minNumberNombreChambres = document.getElementById('min-number-nombreChambres');
            var maxNumberNombreChambres = document.getElementById('max-number-nombreChambres');
            var minRangeNombreChambres = document.getElementById('min-range-nombreChambres');
            var maxRangeNombreChambres = document.getElementById('max-range-nombreChambres');

            noUiSlider.create(sliderNombreChambres, {
                start: [minNumberNombreChambres.value, maxNumberNombreChambres.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeNombreChambres.innerHTML),
                    'max': Number(maxRangeNombreChambres.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderNombreChambres.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberNombreChambres.value = value;
                } else {
                    minNumberNombreChambres.value = value;
                }
            });

            sliderNombreChambres.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberNombreChambres.addEventListener('change', function() {
                sliderNombreChambres.noUiSlider.set([this.value, null]);
            });

            maxNumberNombreChambres.addEventListener('change', function() {
                sliderNombreChambres.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.distance = function() {
        if ($('#nouisliderDistance').length) {
            var sliderDistance = document.getElementById('nouisliderDistance');
            var minNumberDistance = document.getElementById('min-number-distance');
            var maxNumberDistance = document.getElementById('max-number-distance');
            var minRangeDistance = document.getElementById('min-range-distance');
            var maxRangeDistance = document.getElementById('max-range-distance');

            noUiSlider.create(sliderDistance, {
                start: [minNumberDistance.value, maxNumberDistance.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeDistance.innerHTML),
                    'max': Number(maxRangeDistance.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function ( value ) {
                        return value + '';
                    },
                    from: function ( value ) {
                        return value.replace('', '');
                    }
                }
            });

            sliderDistance.noUiSlider.on('update', function (values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberDistance.value = value;
                } else {
                    minNumberDistance.value = value;
                }
            });

            sliderDistance.noUiSlider.on('change', function(){
                self.search();
            });

            minNumberDistance.addEventListener('change', function () {
                sliderDistance.noUiSlider.set([this.value, null]);
            });

            maxNumberDistance.addEventListener('change', function () {
                sliderDistance.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.duration = function() {
        if ($('#nouisliderDuration').length) {
            var sliderDuration = document.getElementById('nouisliderDuration');
            var minNumberDuration = document.getElementById('min-number-duration');
            var maxNumberDuration = document.getElementById('max-number-duration');
            var minRangeDuration = document.getElementById('min-range-duration');
            var maxRangeDuration = document.getElementById('max-range-duration');

            noUiSlider.create(sliderDuration, {
                start: [minNumberDuration.value, maxNumberDuration.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeDuration.innerHTML),
                    'max': Number(maxRangeDuration.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function ( value ) {
                        return value + '';
                    },
                    from: function ( value ) {
                        return value.replace('', '');
                    }
                }
            });

            sliderDuration.noUiSlider.on('update', function (values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberDuration.value = value;
                } else {
                    minNumberDuration.value = value;
                }
            });

            sliderDuration.noUiSlider.on('change', function(){
                self.search();
            });

            minNumberDuration.addEventListener('change', function () {
                sliderDuration.noUiSlider.set([this.value, null]);
            });

            maxNumberDuration.addEventListener('change', function () {
                sliderDuration.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.elevation = function() {
        if ($('#nouisliderElevation').length) {
            var sliderElevation = document.getElementById('nouisliderElevation');
            var minNumberElevation = document.getElementById('min-number-elevation');
            var maxNumberElevation = document.getElementById('max-number-elevation');
            var minRangeElevation = document.getElementById('min-range-elevation');
            var maxRangeElevation = document.getElementById('max-range-elevation');

            noUiSlider.create(sliderElevation, {
                start: [minNumberElevation.value, maxNumberElevation.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeElevation.innerHTML),
                    'max': Number(maxRangeElevation.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function ( value ) {
                        return value + '';
                    },
                    from: function ( value ) {
                        return value.replace('', '');
                    }
                }
            });

            sliderElevation.noUiSlider.on('update', function (values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberElevation.value = value;
                } else {
                    minNumberElevation.value = value;
                }
            });

            sliderElevation.noUiSlider.on('change', function(){
                self.search();
            });

            minNumberElevation.addEventListener('change', function () {
                sliderElevation.noUiSlider.set([this.value, null]);
            });

            maxNumberElevation.addEventListener('change', function () {
                sliderElevation.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.search = function() {

        loadData = true;
        var href = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + $("#searchForm").serialize();
        $('.searchBlock input').attr("disabled", true);
        Apidae_Util.ajaxSend();
        //$("html:not(:animated),body:not(:animated)").animate({ scrollTop: Apidae_Layout.theGridOffsetTop }, 500);
        //Apidae_Layout.gridScrollBar.mCustomScrollbar("scrollTo", "top");

        $.get(href, function (data) {
            var jqObj = $(data);

            if (history && history.pushState) {
                history.pushState({path: this.path}, '', href);
            }

            $('.top-bar__headline').remove();
            $('.searchBlock').prepend(jqObj.find(".top-bar__headline"));

            $('#searchForm').remove();
            $('.searchBlock').append(jqObj.find("#searchForm"));
            $('#searchBtn').hide();

            var elements = $('.grid .grid__item');
            var items = $(jqObj.find(".grid .grid__item"));

            var newPaginationPager = $(jqObj.find(".paginationPager"));
            $('.paginationPager').remove();
            $('.grid__wrapper .pagination').append(newPaginationPager);

            var newPaginationAjax = $(jqObj.find(".paginationAjax"));
            $('.paginationAjax').remove();
            $('.grid__wrapper .pagination').append(newPaginationAjax);

            imagesLoaded(items, function() {
                $('.grid').empty().append(items);
                Apidae_Map.setMarkers(true);
            });

            self.price();
            self.capacity();
            self.distance();
            self.duration();
            self.elevation();
            loadData = false;
            Apidae_Util.ajaxComplete();
        });

    };

    self.init = function(){
        // hide search button when javascript enabled
        $('#searchBtn').hide();

        //toggle filter block dropdown mobile
        $('.sidebar-filter').on('click', '.searchBlockHeaderBtn', function() {
            $(".searchBlockContent").animate({
                height: 'toggle'
            }, 1000, function() {
                // Animation complete.
            });
            $(this).toggleClass("highlight");
            $('#searchButton .fa-chevron-down, #searchButton .fa-chevron-up').toggle();
        });

        //toggle filter dropdown mobile
        $('.sidebar-filter').on('click','.cd-filter-block h4',function(){
            $(this).toggleClass('closed').siblings('.cd-filter-content').slideToggle(300);
        });

        self.price();
        self.capacity();
        self.distance();
        self.duration();
        self.elevation();

        // calendar search
        $('.searchBlock').on('change', '#fieldDate input[type=date]', function() {
            $(this).select();
            $('input[value=calendar]').attr('checked', true);
            self.search();
        });


        // search + map (ajax)
        $(document.body).on('click', '.searchBlock input.filter', function() {
            self.search();
        });

        // checked critere de recherche en déplaçant la carte
        $("#searchByMap").on('change', function(){
            var critereSearchByMap = $("#searchByMap").is(':checked');
            //console.log(critereSearchByMap);
            if(critereSearchByMap){
                $("#critereSearchByMap").val(1).attr('checked', true);
            }else{
                $("#critereSearchByMap").val(0).attr('checked', false);
            }
        });

        // search (Critères de tri)
        $('#tri').on('change', function(){
            var critereTri = $(this).val();
            $('#critereTri').val(critereTri);
            self.search();
        });

    };

    return self;
})();

$(window).load(function(){
    Apidae_Search.init();
});
